<template>
  <div class="cookie-settings">
    <h2 class="cookie-settings__headline">
      {{ $t("headline") }}
    </h2>
    <p class="cookie-settings__copy">
      {{ $t("copy") }}
      <a
        :href="$options.privacyPath"
        class="cookie-settings__privacy">
        <span>{{ $t("privacy") }}</span>
      </a>
    </p>
    <form
      class="cookie-settings__form">
      <div class="cookie-settings__fields">
        <cookie-field
          class="cookie-settings__field"
          name="necessary"
          :disabled="true"
          v-model="necessary" />
        <cookie-field
          class="cookie-settings__field"
          name="preferences"
          v-model="preferences" />
        <cookie-field
          class="cookie-settings__field"
          name="statistics"
          v-model="statistics" />
        <cookie-field
          class="cookie-settings__field"
          name="marketing"
          v-model="marketing" />
      </div>
      <div class="cookie-settings__actions">
        <button
          @click.prevent="onSubmit"
          type="button"
          class="cookie-settings__cta js-pw-link"
          data-event-category="popup-20200728-cookie_settings_submit"
          data-event-depth="1"
          data-event-action="click">
          <span class="button button--full button--midnight">{{ $t('saveSelection') }}</span>
        </button>
        <button
          type="button"
          class="cookie-settings__consent-all js-pw-link"
          data-modal-open-step="cookie-banner:settings"
          @click="$store.dispatch('consentAllCookies')"
          data-event-category="popup-20200728-cookie_settings_all"
          data-event-depth="1"
          data-event-action="click">
          <span>{{ $t('allCookies') }}</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CookieField from "./cookie-field";
import globals from "/utils/globals";

export default {
  name: "CookieSettings",
  components: {
    CookieField
  },
  privacyPath: globals.routes.privacyCookiebot,
  data() {
    return {
      necessary: true,
      preferences: false,
      statistics: false,
      marketing: false
    };
  },
  computed: {
    ...mapState({
      options: state => state.user.cookies.options
    })
  },
  watch: {
    options: {
      handler(v) {
        this.necessary = v.necessary;
        this.preferences = v.preferences;
        this.statistics = v.statistics;
        this.marketing = v.marketing;
      },
      immediate: true
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Change cookie settings",
        copy: "We use them to offer you a better browsing experience, enable social media features, personalise ads and to analyse the traffic.",
        privacy: "Our privacy policy",
        saveSelection: "Save selection",
        allCookies: "Allow all cookies"
      },
      de: {
        headline: "Cookie-Einstellungen anpassen",
        copy: "Wir möchten Cookies dafür nutzen, unsere Website zu analysieren und sie für dich zu verbessern, sowie für Werbezwecke.",
        privacy: "Unsere Datenschutzbestimmung",
        saveSelection: "Auswahl speichern",
        allCookies: "Alle Cookies erlauben"
      }
    }
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("consentCookies", {
        necessary: this.necessary,
        preferences: this.preferences,
        statistics: this.statistics,
        marketing: this.marketing
      });
    }
  }
};

</script>

<style lang="scss">
.cookie-settings {
  @include font-family(sans-serif);

  max-width: 35rem;
  padding: $spacing-24 $spacing-16;

  &__headline {
    @include font-style(h3);

    margin-bottom: $spacing-8;
  }

  &__copy {
    @include font-style(p);

    margin-bottom: $spacing-16;
  }

  &__privacy {
    display: inline-block;
  }

  &__fields {
    margin-bottom: $spacing-24;
    padding-top: $spacing-16;

    border-top: 1px solid $lightest-grey;
  }

  &__field {

    &:not(:last-child) {
      margin-bottom: $spacing-16;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__cta {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: $spacing-16;

    font-family: inherit;

    cursor: pointer;

    /* stylelint-disable-next-line selector-nested-pattern */
    span {
      max-width: $wide-block-width;
    }
  }

  &__consent-all {
    @include font-style(button, $color: $mid-grey);

    font-family: inherit;

    cursor: pointer;

    &:hover {
      color: $midnight;
    }
  }

  @include media(min-width, m) {
    padding: $spacing-24 $spacing-24;
  }
}
</style>
